import { colorsPalettes } from "@similarweb/styles";

import type { ChangeSolutionStepsType } from "app/components/ChangeSolutionModal/consts";
import { changeSolutionSteps } from "app/components/ChangeSolutionModal/consts";
import type { IStepConfig, IUseCaseStepConfig, UseCaseGroupKey } from "app/components/ChangeSolutionModal/types";
import { SolutionType, USE_CASE_GROUPS } from "app/components/ChangeSolutionModal/types";

const { blue, carbon } = colorsPalettes;

export const CHANGE_SOLUTION_STEPS: Record<ChangeSolutionStepsType, IStepConfig> = {
    [changeSolutionSteps.welcome]: {
        id: changeSolutionSteps.welcome,
        title: "components.shared.change_solution_modal.welcome_step.title",
        subTitle: "components.shared.change_solution_modal.welcome_step.subtitle",
        trackingEventName: "welcome back",
        buttons: {
            showBack: false,
            showNext: true,
            showSkip: true,
        },
    },
    [changeSolutionSteps.useCase]: {
        id: changeSolutionSteps.useCase,
        title: "components.shared.change_solution_modal.use_case_step.title",
        subTitle: "components.shared.change_solution_modal.use_case_step.subtitle",
        trackingEventName: "choose your focus",
        buttons: {
            showBack: true,
            showNext: true,
            showSkip: true,
            nextButtonDisabled: true,
        },
    },
    [changeSolutionSteps.currentSolution]: {
        id: changeSolutionSteps.currentSolution,
        title: "components.shared.change_solution_modal.current_solution_step.title",
        subTitle: "components.shared.change_solution_modal.current_solution_step.subtitle",
        trackingEventName: "you are all set",
        isLastStep: true,
        buttons: {
            showBack: true,
            showNext: true,
            showSkip: false,
        },
    },
    [changeSolutionSteps.newSolution]: {
        id: changeSolutionSteps.newSolution,
        title: "components.shared.change_solution_modal.select_new_solution_step.title",
        subTitle: "components.shared.change_solution_modal.select_new_solution_step.subtitle",
        trackingEventName: "start your free trial",
        importantText: "components.shared.change_solution_modal.select_new_solution_step.important_text",
        isLastStep: true,
        buttons: {
            showBack: true,
            showNext: true,
            showSkip: true,
        },
    },
};

export const USE_CASE_STEP_CONFIG: Record<UseCaseGroupKey, IUseCaseStepConfig> = {
    analyzeWebsite: {
        title: "components.shared.change_solution_modal.use_case.analyze_websites",
        value: USE_CASE_GROUPS.analyzeWebsite,
        solution: SolutionType.marketing,
    },
    improveSEO: {
        title: "components.shared.change_solution_modal.use_case.improve_seo",
        value: USE_CASE_GROUPS.improveSEO,
        solution: SolutionType.marketing,
    },
    analyzeApps: {
        title: "components.shared.change_solution_modal.use_case.analyze_apps",
        value: USE_CASE_GROUPS.analyzeApps,
        solution: SolutionType.apps,
    },
    findLeads: {
        title: "components.shared.change_solution_modal.use_case.find_leads",
        value: USE_CASE_GROUPS.findLeads,
        solution: SolutionType.sales,
    },
    exploreAmazon: {
        title: "components.shared.change_solution_modal.use_case.explore_amazon",
        value: USE_CASE_GROUPS.exploreAmazon,
        solution: SolutionType.shopper,
    },
};

export const changeSolutionModalStyled = {
    content: {
        width: "870px",
        height: "590px",
        padding: 0,
    },
};
